<app-breadcrumb  [master]="'Narzędzia'" [parentName]="'Mailing'" [name]="'Dodaj'"></app-breadcrumb>
<div class="email-send-add-container" fxLayout="column" fxLayoutGap="15px"  >
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button  (click)="sendForm()"  [disabled]="processingRequest"  [class.spinner]="processingRequest"   mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Wyślij</span></button>
    <button (click)="cancel()"   mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxLayout="column" fxFlex="70" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3> Email</h3>
        </div>
        <div fxLayout="row"  fxLayoutAlign="center">

          <!--          <mat-form-field fxFlex="100">-->
          <!--            <mat-label>DW</mat-label>-->

          <!--            <input [required]="false"-->
          <!--                   [formControl]="dwControl"-->
          <!--                    matInput placeholder="DW"  >-->
          <!--          </mat-form-field>-->
                    <mat-form-field fxFlex="100">
                      <mat-label>Do</mat-label>
                      <mat-chip-list [formControl]="toControl" #doChipList>
                        <mat-chip *ngFor="let chip of toControl.value; let i = index" [removable]="true" (removed)="remove(i, 'to')">
                          {{chip}}
                          <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <input matInput [matChipInputFor]="doChipList"
                               [matChipInputSeparatorKeyCodes]="separatorKeys"
                               [matChipInputAddOnBlur]="true"
                               (matChipInputTokenEnd)="add($event, 'to')"
                               placeholder="Wpisz wartość" />
                      </mat-chip-list>
                    </mat-form-field>

        </div>
        <div fxLayout="row"  fxLayoutAlign="center">

<!--          <mat-form-field fxFlex="100">-->
<!--            <mat-label>DW</mat-label>-->

<!--            <input [required]="false"-->
<!--                   [formControl]="dwControl"-->
<!--                    matInput placeholder="DW"  >-->

<!--          </mat-form-field>-->
<!--          <mat-form-field fxFlex="100">-->
<!--            <mat-label>DW</mat-label>-->
<!--            <mat-chip-list [formControl]="dwControl" #dwChipList>-->
<!--              <mat-chip *ngFor="let chip of dwControl.value; let i = index" [removable]="true" (removed)="remove(i, 'dw')">-->
<!--                {{chip}}-->
<!--                <mat-icon matChipRemove>cancel</mat-icon>-->
<!--              </mat-chip>-->
<!--              <input matInput [matChipInputFor]="dwChipList"-->
<!--                     (matChipInputTokenEnd)="add($event, 'dw')" placeholder="Wpisz wartość" />-->
<!--            </mat-chip-list>-->
<!--          </mat-form-field>-->

        </div>
        <div fxLayout="row"  fxLayoutAlign="center">

<!--          <mat-form-field fxFlex="100">-->
<!--            <mat-label>UDW</mat-label>-->

<!--            <input [required]="false"-->
<!--                   [formControl]="udwControl"-->
<!--                    matInput placeholder="UDW"  >-->

<!--          </mat-form-field>-->
<!--          <mat-form-field fxFlex="100">-->
<!--            <mat-label>UDW</mat-label>-->
<!--            <mat-chip-list [formControl]="udwControl" #udwChipList>-->
<!--              <mat-chip *ngFor="let chip of udwControl.value; let i = index" [removable]="true" (removed)="remove(i, 'udw')">-->
<!--                {{chip}}-->
<!--                <mat-icon matChipRemove>cancel</mat-icon>-->
<!--              </mat-chip>-->
<!--              <input matInput [matChipInputFor]="udwChipList"-->
<!--                     (matChipInputTokenEnd)="add($event, 'udw')" placeholder="Wpisz wartość" />-->
<!--            </mat-chip-list>-->
<!--          </mat-form-field>-->


        </div>
        <div fxLayout="row"  fxLayoutAlign="center">

          <mat-form-field fxFlex="100">
            <mat-label>Tytuł maila</mat-label>

            <input [required]="true"
                   [formControl]="titleControl"
                   appCapitalizeFirst matInput placeholder="Tytuł maila"  >

          </mat-form-field>
        </div>

        <div fxLayout="row"  fxLayoutAlign="center">

          <angular-editor fxFlex="100" [config]="editorConfig" [formControl]="contentControl"  ></angular-editor>
        </div>
        <div fxLayout="row"  fxLayoutAlign="center">

          <app-file-drag-and-drop fxFlex="100" [maxSize]="maxSize"  [multiple]="true" [resetFilesOnAdd]="false" acceptMime="*/*"   [fileControl]="fileControl"></app-file-drag-and-drop>
        </div>
        <!--          <div *ngIf="postObject.attachments" fxLayoutAlign="space-between center" fxFlex="100">-->
        <!--            <img class=" avatar-360" src="/rest/crm/asf360/file/{{formGroup.get('postDetailFileLocation').value}}/image/{{formGroup.get('postDetailFilename').value}}" alt="Zdjęcie"/>-->
        <!--          </div>-->

      </mat-card>

    </div>

    <div fxLayout="column" fxFlex="30"  fxLayoutGap="20px"  >
      <mat-card>
        <div fxLayout="row">
          <h3>Odbiorcy</h3>
        </div>

        <div fxLayout="row" fxLayoutGap="20px" *ngIf="!profile.regionalId">
          <div  fxFlex="100">
            <mat-slide-toggle [formControl]="filterByRegionalControl" >Regionalni</mat-slide-toggle>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="20px" *ngIf="filterByRegionalControl.value">
          <div  fxFlex="100">
            <app-dict-regionals  [formControl]="regionalControl"
                                 [multiple]="true"
                                 [required]="false"
                                 fxFlex="100"
                                 label="Regionalni">
            </app-dict-regionals>
          </div>
        </div>


        <div fxLayout="row" fxLayoutGap="20px">
          <div  fxFlex="100">
            <mat-slide-toggle [formControl]="partnerControl" >Partner</mat-slide-toggle>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="20px" *ngIf="partnerControl.value">
          <h4>Parametry ograniczające liczbę odbiorców</h4>
        </div>

        <div fxLayout="row" fxLayoutGap="20px" *ngIf="partnerControl.value">
          <div  fxFlex="100" fxLayoutAlign="space-between center" >
            <mat-slide-toggle [formControl]="basicEmailControl"  > Email podstawowy </mat-slide-toggle>
            <span matTooltip="Wiadomość zostanie wysłana do wszystkich Partnerów w Twojej strukturze"   >
              <mat-icon>info</mat-icon>
            </span>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="20px" *ngIf="partnerControl.value">
          <div  fxFlex="100" fxLayoutAlign="space-between center" >
            <mat-slide-toggle [formControl]="productEmailControl" > Email produktowy </mat-slide-toggle>
            <span  matTooltip="Wiadomość zostanie wysłana do wszystkich Partnerów, którzy wyrazili zgodę na wiadomości produktowe"   >
              <mat-icon>info</mat-icon>
            </span>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="20px" *ngIf="partnerControl.value">
          <div  fxFlex="100" fxLayoutAlign="space-between center" >
            <mat-slide-toggle [formControl]="contestEmailControl"  > Email konkursowy </mat-slide-toggle>
            <span matTooltip="Wiadomość zostanie wysłana do wszystkich Partnerów, którzy wyrazili zgodę na wiadomości konkursowe"   >
              <mat-icon>info</mat-icon>
            </span>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="20px" *ngIf="partnerControl.value">
          <div  fxFlex="100" fxLayoutAlign="space-between center" >
            <mat-slide-toggle [formControl]="billingEmailControl"   > Email rozliczeniowy </mat-slide-toggle>
            <span   matTooltip="Wiadomość zostanie wysłana tylko do Partnerów"  >
              <mat-icon>info</mat-icon>
            </span>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign=" center" *ngIf="partnerControl.value">
          <div  fxFlex="100" fxLayoutAlign="space-between center" >
            <mat-slide-toggle  [formControl]="registrationControl" >Rejestracja </mat-slide-toggle>
            <span  matTooltip="Wiadomość zostanie wysłana do wszystkich Partnerów, którzy posiadają co najmniej jedną rejestrację w statusie Zarejestrowana we wskazanych TU"  >
              <mat-icon>info</mat-icon>
            </span>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign=" center" >
          <div  fxFlex="100" *ngIf="registrationControl.value && partnerControl.value">
            <app-dict-insurance-companies
              [formControl]="registrationListControl"
              [multiple]="true"
              [required]="registrationControl.value"
              fxFlex="100"
              label="Rejestracje"
            ></app-dict-insurance-companies>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="20px" *ngIf="profile.permissions['mailing']==='admin_root'&&partnerControl.value">
          <div  fxFlex="100">
            <app-dict  [label]="'Status Partnera'"
                       [dictType]="'partner_status'"
                       [required]="false"
                       [multiple]="false"
                       [formControl]="statusPartnerControl"
                       [skipKeys]="[PARTNER_STATUS_INACTIVE]"
            ></app-dict>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="20px" *ngIf="profile.permissions['mailing']==='admin_root'&&partnerControl.value">
          <div  fxFlex="100">
            <app-dict [label]="'Typ umowy Partner'"
                      [dictType]="'contract_type'"
                      [required]="false"
                      [multiple]="false"
                      [formControl]="contractTypeControl"
            ></app-dict>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="20px" *ngIf="profile.permissions['mailing']==='admin_root'&&partnerControl.value">
          <div  fxFlex="100">
            <app-dict [label]="'Status umowy Partnera'"
                      [dictType]="'contract_status'"
                      [required]="false"
                      [multiple]="false"
                      [formControl]="contractStatusControl"
            ></app-dict>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="20px" *ngIf="partnerControl.value">
          <div  fxFlex="100" >
            <app-dict  [label]="'Tagi Partnera'"
                       [dictType]="'partner_tags'"
                       [required]="false"
                       [multiple]="false"
                       [formControl]="tagPartnerControl"></app-dict>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="20px">
          <div  fxFlex="100">
            <mat-slide-toggle [formControl]="ofwcaControl" >OFWCA</mat-slide-toggle>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="20px" *ngIf="ofwcaControl.value">
          <h4>Parametry ograniczające liczbę odbiorców</h4>
        </div>

        <div fxLayout="row" fxLayoutGap="20px" *ngIf="ofwcaControl.value">
          <div  fxFlex="100" fxLayoutAlign="space-between center" >
            <mat-slide-toggle [formControl]="basicEmailOfwcaControl"  > Email podstawowy </mat-slide-toggle>
            <span matTooltip="Wiadomość zostanie wysłana do wszystkich OFWCA w Twojej strukturze"   >
              <mat-icon>info</mat-icon>
            </span>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="20px" *ngIf="ofwcaControl.value">
          <div  fxFlex="100" fxLayoutAlign="space-between center" >
            <mat-slide-toggle [formControl]="productEmailOfwcaControl" > Email produktowy </mat-slide-toggle>
            <span  matTooltip="Wiadomość zostanie wysłana do wszystkich OFWCA, którzy wyrazili zgodę na wiadomości produktowe"   >
              <mat-icon>infox</mat-icon>
            </span>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="20px" *ngIf="ofwcaControl.value">
          <div  fxFlex="100" fxLayoutAlign="space-between center" >
            <mat-slide-toggle [formControl]="contestEmailOfwcaControl"  > Email konkursowy </mat-slide-toggle>
            <span matTooltip="Wiadomość zostanie wysłana do wszystkich OFWCA, którzy wyrazili zgodę na wiadomości konkursowe"   >
              <mat-icon>info</mat-icon>
            </span>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign=" center" *ngIf="ofwcaControl.value">
          <div  fxFlex="100" fxLayoutAlign="space-between center" >
            <mat-slide-toggle  [formControl]="registrationOfwcaControl" >Rejestracja </mat-slide-toggle>
            <span  matTooltip="Wiadomość zostanie wysłana do wszystkich OFWCA, którzy posiadają co najmniej jedną rejestrację w statusie Zarejestrowana we wskazanych TU"  >
              <mat-icon>info</mat-icon>
            </span>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign=" center" *ngIf="registrationOfwcaControl.value && ofwcaControl.value">
          <div  fxFlex="100" >
            <app-dict-insurance-companies
              [formControl]="registrationListOfwcaControl"
              [multiple]="true"
              [required]="registrationOfwcaControl.value"
              fxFlex="100"
              label="Rejestracje"
            ></app-dict-insurance-companies>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="20px" *ngIf="ofwcaControl.value">
          <div  fxFlex="100">
              <app-dict  [label]="'Tagi Partnera'"
                         [dictType]="'partner_tags'"
                         [required]="false"
                         [multiple]="false"
                         [formControl]="tagPartnerOfwcaControl"></app-dict>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="20px" *ngIf="ofwcaControl.value">
          <div  fxFlex="100">
            <app-dict [label]="'Statusy szkoleń IDD'"
                      [dictType]="'idd_training_status'"
                      [required]="false"
                      [multiple]="false"
                      [formControl]="iddTrainingStatusControl"
                      [matTooltip]="'Wiadomość zostanie wysłana tylko do OFWCA, które w bieżącym roku posiadają wskazany status szkoleń IDD'"
            ></app-dict>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="20px" *ngIf="profile.permissions['mailing']==='admin_root'">
          <div  fxFlex="100">
            <mat-slide-toggle [formControl]="employeeASF24Control" >Pracownicy</mat-slide-toggle>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="20px" *ngIf="employeeASF24Control.value">
          <h4>Parametry ograniczające liczbę odbiorców</h4>
        </div>

        <div fxLayout="row" fxLayoutGap="20px" *ngIf="employeeASF24Control.value">
          <div  fxFlex="100">
            <app-dict-departments
              [label]="'Dział'"
                       [required]="false"
                       [multiple]="true"
                       [formControl]="departmentListControl"></app-dict-departments>
          </div>
        </div>

        <div fxLayout="row">
          <h5 *ngIf="!profile?.regionalId">
            Maile do grupy Profitowi nie są wysyłane
          </h5>

        </div>

      </mat-card>

    </div>
  </div>


  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button  (click)="sendForm()"  [disabled]="processingRequest"  [class.spinner]="processingRequest"   mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Wyślij</span></button>
    <button (click)="cancel()"  mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
